import { isTransportFailure } from '~/helpers/network-errors'

export default {
  getCm24Setting ({
    commit,
    state
  }, key) {
    return this.$axios.get('/public/settings/' + key).then((response) => {
      commit('setCm24Setting', response.data)
      return response.data
    }).catch((error) => {
      // Settings are advisory: kill switches default to off server-side too, and
      // the system bar is only shown when explicitly enabled. A request that
      // never reached the API must therefore not take the caller's flow down
      // with it — losing the ad submit over a flaky mobile connection is far
      // worse than acting on the default.
      if (!isTransportFailure(error)) {
        throw error
      }

      return state.settings[key] || {
        key,
        value: null
      }
    })
  }
}
